import React, { useEffect } from "react";
import { Link } from "react-router-dom";

const ChangeLog = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <section className="breadcrumb-area off-white-bc">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 offset-lg-3 col-12">
              <div className="breadcrumb-content web-realise-title">
                <h3>Change Log</h3>
                <p>
                  Always up to date! Manager is being continuously updated to
                  keep getting better than ever.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="web-realise-area">
        <div className="container">
          <div className="web-realise-inner">
            <div className="row">
              <div className="col-12">
                <div className="single-realise b-line">
                  <div className="realise-date">
                    <span>December</span>
                    <h6>2020</h6>
                  </div>
                  <ul className="realise-list">
                    <li>
                      <span>20 Dec,2020</span>
                      <p>
                        Complete the paragraph’s idea or transition into the
                        next paragraph
                      </p>
                      <Link to="/changelogdetails">See details</Link>
                    </li>
                    <li>
                      <span>20 Dec,2020</span>
                      <p>Get connected to the high speed internet.</p>
                      <Link to="/changelogdetails">See details</Link>
                    </li>
                  </ul>
                </div>
                <div className="single-realise b-line">
                  <div className="realise-date">
                    <span>November</span>
                    <h6>2020</h6>
                  </div>
                  <ul className="realise-list">
                    <li>
                      <span>20 Nov,2020</span>
                      <p>
                        The Pandavas defeated the Kauravas. The Bhagvad Gita is
                        a holy book of the Hindus. It is a part of the
                        Mahabharata.
                      </p>
                      <Link to="/changelogdetails">See details</Link>
                    </li>
                  </ul>
                </div>
                <div className="single-realise">
                  <div className="realise-date">
                    <span>October</span>
                    <h6>2020</h6>
                  </div>
                  <ul className="realise-list">
                    <li>
                      <span>20 Oct,2020</span>
                      <p>
                        The Pandavas defeated the Kauravas. The Bhagvad Gita is
                        a holy book of the Hindus. It is a part of the
                        Mahabharata.
                      </p>
                      <Link to="/changelogdetails">See details</Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ChangeLog;
